import { useEffect } from 'react';
import { consultTest } from 'Api/testConsult';
import { useHistory } from 'react-router-dom';

const useFetch = ({ lessonId, courseId, userId, setUserEvaluation }) => {
  const history = useHistory();

  useEffect(() => {
    consultTest({
      lessonId,
      userId,
      courseId,
    }).then(data => {
      setUserEvaluation(data);
    });
  }, [courseId, lessonId, userId, setUserEvaluation]);

  const startTest = () => {
    history.push({
      pathname: `/cursos/examen/${lessonId}`,
    });
  };

  return {
    startTest,
  };
};

export default useFetch;
